import { render } from "./StudentsMarinePracticeView.vue?vue&type=template&id=61b69e67&scoped=true"
import script from "./StudentsMarinePracticeView.vue?vue&type=script&lang=js"
export * from "./StudentsMarinePracticeView.vue?vue&type=script&lang=js"

import "./StudentsMarinePracticeView.vue?vue&type=style&index=0&id=61b69e67&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b69e67"]])

export default __exports__